var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.65201,
    cy: 7,
    rx: 7.03873,
    ry: 7,
    fill: "#48AB4D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_242_78551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 11,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9012 2.09961H2.72461V12.2325H12.9012V2.09961Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1583 6.33386C10.4888 4.89637 9.1888 3.97887 9.1888 3.97887C9.13484 4.36584 8.96311 4.72023 8.73018 5.03724C8.60826 4.93785 8.48821 4.83629 8.37112 4.73122C7.74482 4.16921 7.19715 3.45692 7.08119 2.62543C7.08119 2.62543 5.44507 3.78013 4.60253 5.58929C4.05514 6.76469 3.87342 8.26929 4.29823 9.41374C4.85705 10.9191 6.39843 11.9355 7.90572 11.9355C9.51964 11.9355 10.9659 10.8805 11.4038 9.35939C11.6978 8.361 11.5695 7.21697 11.1583 6.33386Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91657 8.99653C9.91657 10.1532 8.9749 11.0908 7.81328 11.0908C6.65165 11.0908 5.70996 10.1532 5.70996 8.99653C5.70996 7.20585 7.81328 5.68791 7.81328 5.68791C7.81328 5.68791 9.91657 7.20585 9.91657 8.99653Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91657 8.99653C9.91657 10.1532 8.9749 11.0908 7.81328 11.0908C6.65165 11.0908 5.70996 10.1532 5.70996 8.99653C5.70996 7.20585 7.81328 5.68791 7.81328 5.68791C7.81328 5.68791 9.91657 7.20585 9.91657 8.99653Z",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93155 9.97847C8.93155 10.5928 8.43138 11.0908 7.81441 11.0908C7.19743 11.0908 6.69727 10.5928 6.69727 9.97847C6.69727 9.02736 7.81441 8.22114 7.81441 8.22114C7.81441 8.22114 8.93155 9.02736 8.93155 9.97847Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93155 9.97847C8.93155 10.5928 8.43138 11.0908 7.81441 11.0908C7.19743 11.0908 6.69727 10.5928 6.69727 9.97847C6.69727 9.02736 7.81441 8.22114 7.81441 8.22114C7.81441 8.22114 8.93155 9.02736 8.93155 9.97847Z",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_242_78551)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_242_78551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 11,
    height: 11
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72656 2.09754H12.9032V12.2305H2.72656V2.09754Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_242_78551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1592 6.33191C10.4898 4.89442 9.18978 3.97691 9.18978 3.97691C9.13582 4.36388 8.96409 4.71828 8.73116 5.03529C8.60924 4.9359 8.48918 4.83433 8.37209 4.72926C7.7458 4.16726 7.19813 3.45497 7.08217 2.62348C7.08217 2.62348 5.44604 3.77817 4.60351 5.58734C4.05612 6.76273 3.87439 8.26734 4.29921 9.41178C4.85803 10.9172 6.3994 11.9336 7.90669 11.9336C9.52062 11.9336 10.9668 10.8785 11.4048 9.35744C11.6988 8.35905 11.5705 7.21502 11.1592 6.33191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1592 6.33191C10.4898 4.89442 9.18978 3.97691 9.18978 3.97691C9.13582 4.36388 8.96409 4.71828 8.73116 5.03529C8.60924 4.9359 8.48918 4.83433 8.37209 4.72926C7.74579 4.16726 7.19813 3.45497 7.08217 2.62348C7.08217 2.62348 5.44604 3.77817 4.60351 5.58734C4.05612 6.76273 3.87439 8.26734 4.29921 9.41178C4.85803 10.9172 6.3994 11.9336 7.90669 11.9336C9.52062 11.9336 10.9668 10.8785 11.4048 9.35744C11.6988 8.35905 11.5705 7.21502 11.1592 6.33191Z",
    stroke: "white",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91853 8.99555C9.91853 10.1522 8.97685 11.0898 7.81523 11.0898C6.65361 11.0898 5.71191 10.1522 5.71191 8.99555C5.71191 7.20488 7.81523 5.68694 7.81523 5.68694C7.81523 5.68694 9.91853 7.20488 9.91853 8.99555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91853 8.99555C9.91853 10.1522 8.97685 11.0898 7.81523 11.0898C6.65361 11.0898 5.71191 10.1522 5.71191 8.99555C5.71191 7.20488 7.81523 5.68694 7.81523 5.68694C7.81523 5.68694 9.91853 7.20488 9.91853 8.99555Z",
    stroke: "white",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93155 9.9775C8.93155 10.5918 8.43138 11.0898 7.81441 11.0898C7.19743 11.0898 6.69727 10.5918 6.69727 9.9775C6.69727 9.02639 7.81441 8.22017 7.81441 8.22017C7.81441 8.22017 8.93155 9.02639 8.93155 9.9775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93155 9.9775C8.93155 10.5918 8.43138 11.0898 7.81441 11.0898C7.19743 11.0898 6.69727 10.5918 6.69727 9.9775C6.69727 9.02639 7.81441 8.22017 7.81441 8.22017C7.81441 8.22017 8.93155 9.02639 8.93155 9.9775Z",
    stroke: "white",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaz);
export default __webpack_public_path__ + "static/media/gaz.5322b21c04d73897001b0c9230e217ec.svg";
export { ForwardRef as ReactComponent };